import React from 'react';

function Folder(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M4.96875 4.04736L8.59375 4.0473C9.18414 4.0473 9.74031 4.32521 10.0938 4.7973L11.4798 6.74631L19.0938 6.74637C20.0796 6.74637 20.8883 7.50811 20.9631 8.47489L20.9688 8.62137L20.9688 17.1251C20.9688 18.1603 20.1289 19.0001 19.0938 19.0001H4.96875C3.93357 19.0001 3.09375 18.1603 3.09375 17.1251V5.92236C3.09375 4.88719 3.93357 4.04736 4.96875 4.04736ZM8.59375 5.2973L4.96875 5.29736C4.62393 5.29736 4.34375 5.57754 4.34375 5.92236V17.1251C4.34375 17.47 4.62393 17.7501 4.96875 17.7501H19.0938C19.4386 17.7501 19.7188 17.47 19.7188 17.1251L19.7188 8.62137C19.7188 8.27655 19.4386 7.99637 19.0938 7.99637L11.1678 7.99631C10.971 7.99631 10.7858 7.90368 10.6678 7.74631L9.09343 5.54688C8.97589 5.38987 8.79063 5.2973 8.59375 5.2973Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Folder;
